import React, { useEffect, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import LoginHeader from './components/LoginHeader';
import LoginForm from './components/LoginForm';

const Login = () => {
  const navigate = useNavigate();

  // Memoizar a verificação de autenticação para evitar re-renders desnecessários
  const isAuthenticated = useMemo(() => {
    return !!localStorage.getItem('user');
  }, []);

  useEffect(() => {
    // Verificação otimizada de autenticação
    if (isAuthenticated) {
      navigate('/dashboard', { replace: true });
    }
  }, [isAuthenticated, navigate]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-white to-blue-50">
      {/* Background Pattern Otimizado */}
      <div 
        className="absolute inset-0 opacity-[0.02]"
        style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='40' height='40' viewBox='0 0 40 40' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='%23000000' fill-opacity='0.1'%3E%3Ccircle cx='20' cy='20' r='2'/%3E%3C/g%3E%3C/svg%3E")`,
          backgroundSize: '40px 40px'
        }}
      />

      {/* Main Content */}
      <div className="relative z-10 flex min-h-screen">
        {/* Login Form - Centralizado */}
        <div className="flex-1 flex items-center justify-center px-4 py-8">
          <div className="w-full max-w-md">
            {/* Card Principal */}
            <div className="bg-white/80 backdrop-blur-sm border border-slate-200/50 rounded-2xl shadow-xl p-8">
              <LoginHeader />
              <LoginForm />
            </div>

            {/* Footer Minimalista */}
            <div className="mt-8 text-center">
              <p className="text-xs text-slate-500">
                © {new Date().getFullYear()} HNP Pro. Todos os direitos reservados.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;